<div class="container">

  <app-header-dialog [iconName]="'live_tv'">
    Webinars
  </app-header-dialog>

  <div class='tab-content'>

    <iframe width="790px" height="550px" [src]="path_url" frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

  </div>

</div>